import { useEffect, useState } from "react";

// Respect the OS/browser "reduce motion" setting.
export function useReducedMotion() {
  const [reduced, setReduced] = useState(false);
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReduced(mq.matches);
    const handler = (e) => setReduced(e.matches);
    try { mq.addEventListener("change", handler); } catch { mq.addListener(handler); }
    return () => {
      try { mq.removeEventListener("change", handler); } catch { mq.removeListener(handler); }
    };
  }, []);
  return reduced;
}

export default useReducedMotion;
